var _path;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
import React from "react";
var SvgWarningIcon = function SvgWarningIcon(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 20L12.2632 4L21.5263 20H3ZM5.90526 18.3158H18.6211L12.2632 7.36842L5.90526 18.3158ZM12.2632 17.4737C12.5018 17.4737 12.7018 17.393 12.8632 17.2316C13.0246 17.0702 13.1053 16.8702 13.1053 16.6316C13.1053 16.393 13.0246 16.193 12.8632 16.0316C12.7018 15.8702 12.5018 15.7895 12.2632 15.7895C12.0246 15.7895 11.8246 15.8702 11.6632 16.0316C11.5018 16.193 11.4211 16.393 11.4211 16.6316C11.4211 16.8702 11.5018 17.0702 11.6632 17.2316C11.8246 17.393 12.0246 17.4737 12.2632 17.4737ZM11.4211 14.9474H13.1053V10.7368H11.4211V14.9474Z",
    fill: "#E68600"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarningIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning_icon.99806cec.svg";
export { ForwardRef as ReactComponent };